import { takeLeading, put, all, call } from 'redux-saga/effects';

import axios from 'axios';

import { getLastRunFailure, getLastRunSuccess } from './tb-automation.actions';

import TBAutomationActionTypes from './tb-automation.types';

export function* getLastRun() {
  try {
    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/automation/tblastrun',
      method: 'get',
    });

    if (response.data.status === 'success') {
      yield put(getLastRunSuccess(response.data.lastrun));
    } else {
      alert('Error getting last run ');
    }
  } catch (error) {
    alert('Error on server while getting last run');
    yield put(getLastRunFailure(error));
  }
}

export function* onGetLastRun() {
  yield takeLeading(TBAutomationActionTypes.GET_LAST_RUN_START, getLastRun);
}

export function* trueblueAutomationSagas() {
  yield all([call(onGetLastRun)]);
}
